module.exports = __webpack_public_path__ + "static/media/franchise-icon.4b3ab5d6.svg";